<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("active loans") }}</div>

    <loan-datatable ref="loan_datatable" />
  </section>
</template>

<script>
import LoanDatatable from "./loan_datatable/Index.vue";

export default {
  name: "Loans",
  components: {
    LoanDatatable,
  },
};
</script>
